<template>
  <VueJsModalPrimary
    v-bind="attrs.modal"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary>
        Change Expiration Policy
      </HeaderLargePrimary>
      <DropdownPrimary
        v-model="selectedExpirationType"
        :idKey="'type'"
        :labelKey="'label'"
        :options="surveyExpirations"
        :style="style.dropdown"
      />
      <div :style="style.footer">
        <ButtonSecondary @click="close">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          :disabled="disableUpdateButton"
          @click="updateExpiration"
        >
          Update
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import DropdownPrimary from '@modules/v2/dropdown/dropdown-primary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalSurveySettingsPrimary',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      DropdownPrimary,
      HeaderLargePrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        initSelectedExpirationType: null,
        selectedExpirationType: null,
        name: MODAL_WINDOW_NAMES.CONFIGURE_SURVEY_PRIMARY,
        attrs: {
          modal: {
            height: 'auto',
            maxWidth: 480,
            name: MODAL_WINDOW_NAMES.CONFIGURE_SURVEY_PRIMARY,
            width: '90%',
          },
        },
        style: {
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: Layout.space.lg,
            width: '100%',
          },
          dropdown: {
            margin: `${Layout.space.xl} 0`,
          },
          footer: {
            display: 'flex',
            height: 'fit-content',
            justifyContent: 'space-between',
            width: '100%',
          },
        },
      };
    },
    computed: {
      ...mapGetters(
        'globalVariables',
        ['getDefaultSurveyExpiration', 'getSurveyExpirationByType'],
      ),
      ...mapState({
        surveyExpirations: state => state.globalVariables.data.surveyExpirations,
      }),
      disableUpdateButton: function () {
        return this.initSelectedExpirationType === this.selectedExpirationType;
      },
      selectedExpiration: function () {
        return this.surveyExpirations
          .filter(elem => elem.id === this.selectedExpirationType)[0];
      },
    },
    methods: {
      beforeOpen: function (e) {
        this.clearCache();

        const expirationType = e?.params?.survey?.expirationType;
        // Do not take expirationType === null as an error,
        // because it's possible.
        if (expirationType === undefined) {
          const errorMessage = 'Failed to load expiration type';
          console.error(errorMessage);
          this.$store.commit('notification/setWarning', errorMessage);
          this.close();
        }

        const selectedExpirationType = (
          this.getSurveyExpirationByType(expirationType) === null
            ? this.getDefaultSurveyExpiration.type
            : this.getSurveyExpirationByType(expirationType).type
        );

        this.initSelectedExpirationType = selectedExpirationType;
        this.selectedExpirationType = selectedExpirationType;
      },
      clearCache: function () {
        this.selectedExpirationType = null;
      },
      close: function () {
        this.$modal.hide(this.name);
      },
      updateExpiration: function () {
        const expiration = this.getSurveyExpirationByType(
          this.selectedExpirationType);
        this.$emit('update-survey-expiration', expiration);
      },
    },
  };
</script>
